// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/vehicleSpecRanges.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (TASK-9715: the ONE set of truck / trailer spec ranges. The Claude connector
// refuses a number outside them; the Roster modals warn on the year bounds.)
// =============================================================================
export const VEHICLE_SPEC_RANGES = Object.freeze({
  "year": {
    "min": 1950,
    "maxYearsAhead": 1,
    "whole": true
  },
  "length": {
    "min": 4,
    "max": 120,
    "decimals": 2,
    "unit": "ft"
  },
  "width": {
    "min": 4,
    "max": 20,
    "decimals": 2,
    "unit": "ft"
  },
  "height": {
    "min": 1,
    "max": 20,
    "decimals": 2,
    "unit": "ft"
  },
  "axleCount": {
    "min": 1,
    "max": 20,
    "whole": true
  },
  "gvwr": {
    "min": 1000,
    "max": 250000,
    "whole": true,
    "unit": "lbs"
  },
  "gcwr": {
    "min": 1000,
    "max": 350000,
    "whole": true,
    "unit": "lbs"
  },
  "curbWeight": {
    "min": 500,
    "max": 150000,
    "whole": true,
    "unit": "lbs"
  },
  "payloadCapacity": {
    "min": 100,
    "max": 250000,
    "whole": true,
    "unit": "lbs"
  },
  "unladenWeight": {
    "min": 500,
    "max": 150000,
    "whole": true,
    "unit": "lbs"
  },
  "gawrFront": {
    "min": 1000,
    "max": 60000,
    "whole": true,
    "unit": "lbs"
  },
  "gawrRear": {
    "min": 1000,
    "max": 80000,
    "whole": true,
    "unit": "lbs"
  },
  "gawr": {
    "min": 1000,
    "max": 80000,
    "whole": true,
    "unit": "lbs"
  }
});
